module.exports = __webpack_public_path__ + "img/Frame 5@2x.1d64ddb3.png";